import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M2 12q2.5 2 5 0t5 0 5 0 5 0', key: '8ddzzs' }],
  ['path', { d: 'M2 19q2.5 2 5 0t5 0 5 0 5 0', key: '1wj4st' }],
  ['path', { d: 'M2 5q2.5 2 5 0t5 0 5 0 5 0', key: '69x50u' }],
];

/**
 * @component @name WavesHorizontal
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiAxMnEyLjUgMiA1IDB0NSAwIDUgMCA1IDAiIC8+CiAgPHBhdGggZD0iTTIgMTlxMi41IDIgNSAwdDUgMCA1IDAgNSAwIiAvPgogIDxwYXRoIGQ9Ik0yIDVxMi41IDIgNSAwdDUgMCA1IDAgNSAwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/waves-horizontal
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const WavesHorizontal = createLucideIcon('waves-horizontal', __iconNode);

export default WavesHorizontal;
